import { store } from '../store/store';
import { getPackageBaseUrl } from 'owa-config';
import { BASE_THEME_ID } from '../utils/themeConstants';
import { addThemeData } from '../mutators/addThemeData';
import ThemeResources from '../store/schema/ThemeResources';
import { getThemeDataName } from '../utils/getThemeDataName';

const THEME_DATA_FOLDER = 'resources/theme/';

const themeFetchPromises: { [themeName: string]: Promise<void> } = {};

export function fetchThemeResource(themeId: string, isDarkTheme: boolean): ThemeResources {
    let themeName = getThemeDataName(themeId, isDarkTheme);
    if (store.themeData.has(themeName)) {
        return store.themeData.get(themeName)!;
    } else {
        fetchThemeFile(themeId, isDarkTheme);

        // The base theme resources are added to the store at initialization
        return store.themeData.get(BASE_THEME_ID)!;
    }
}

export async function fetchThemeFile(themeId: string, isDarkTheme: boolean) {
    let themeName = getThemeDataName(themeId, isDarkTheme);

    const fetchAndLoad = async () => {
        let themeData: ThemeResources;
        try {
            let response = await fetch(
                `${getPackageBaseUrl()}${THEME_DATA_FOLDER}fabric.color.variables.theme.${themeName}.json`
            );
            themeData = await response.json();
        } catch (err) {
            // If we can't find the theme file, then just use the base theme resources
            themeData = fetchThemeResource(BASE_THEME_ID, false);
        }
        addThemeData(themeId, isDarkTheme, themeData);
    };

    return themeFetchPromises[themeName] || (themeFetchPromises[themeName] = fetchAndLoad());
}
